import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import './ToastMessage.scss';

interface ToastMessageProps {
  toast: string;
  close?: () => void;
  hideClose?: boolean;
  messageType?: 'success' | 'error' | 'info';
  autoHideDuration?: number;
  backgroundHidden?: boolean;
}

function ToastMessage({
  toast,
  close = () => {},
  hideClose,
  messageType,
  autoHideDuration,
  backgroundHidden,
}: ToastMessageProps) {
  const action = (
    <>
      <IconButton size='small' aria-label='close' color='inherit' onClick={close}>
        <CloseIcon fontSize='small' />
      </IconButton>
    </>
  );

  return (
    <>
      {!!toast && !backgroundHidden && <Box className='toast-background' onClick={close}></Box>}
      <Box alignSelf='center'>
        <Snackbar
          open={!!toast}
          autoHideDuration={autoHideDuration || 6000}
          action={!hideClose ? action : undefined}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          onClose={!hideClose ? close : undefined}
          className='snackbar'
        >
          <Alert severity={messageType || 'error'} onClose={!hideClose ? close : undefined} className='alert'>
            {toast}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
}

export default ToastMessage;
